import { useEffect } from 'react'

import { ConfigPageHeader } from '@/components/pages/ConfigTimeWork'
import { useConfig } from '@/pages/ConfigTimeWork/ConfigsTimeWork.hooks'

const ConfigTimeWork = () => {
  const { createConfigTime, getConfigResponse, getConfigTime, updateConfigTime, loading } = useConfig()
  const timeConfig = getConfigResponse?.timeExists

  useEffect(() => {
    getConfigTime()
  }, [getConfigTime])

  return (
    <>
      <ConfigPageHeader
        createConfigTime={createConfigTime}
        getConfigResponse={getConfigResponse}
        updateConfigTime={updateConfigTime}
        timeConfig={timeConfig}
        getConfigTime={getConfigTime}
        loading={loading}
      />
    </>
  )
}

ConfigTimeWork.displayName = 'ConfigTimeWork'
export default ConfigTimeWork
